import { FormDialog } from "components/dialog/form"
import { SisetuMatchingFormData } from "interface/sisetu/match"
import { SisetuSelfMatchingForm, useSisetuSelfMatchingForm } from "../form/sisetuSelfMatching"
import { Button } from "@mui/material"
import { useCallback } from "react"

type SisetuSelfMatchingDialogProps = {
	formData: SisetuMatchingFormData
  defaultFormData?: SisetuMatchingFormData
	onSubmit: (data: SisetuMatchingFormData) => void
	onClose: () => void
}
export const SisetuSelfMatchingDialog = ({
	formData,
  defaultFormData,
	onSubmit,
	onClose
}: SisetuSelfMatchingDialogProps) => {
  const form = useSisetuSelfMatchingForm({ formData, onSubmit })
  const onClickedDefault = useCallback(
    () => {
      if (!defaultFormData) return
      form.setValue("name", defaultFormData.name)
      form.setValue("todofuken", defaultFormData.todofuken ?? '')
    },
    [defaultFormData, form]
  )
	return (
    <FormDialog
      open
      fullWidth
      maxWidth="md"
      title="名寄せの再実行"
      body={<SisetuSelfMatchingForm {...form}/>}
      submitLabel="実行"
      isValid={form.formState.isValid}
      leftAction={
        <Button
          variant="outlined"
          disabled={defaultFormData ? false : true}
          size="large"
          onClick={onClickedDefault}
        >
          元に戻す
        </Button>
      }
      onSubmit={form.submit}
      onClose={onClose}
    />
  )
}